import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { GET_ZWAVE_DEVICE_PARAM } from '@app/constants/myDevices/zwaveDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestFailed, apiRequestDone } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/deviceSettings/zwaveDevices'

const getZwaveDeviceParameterLogic = createLogic({
  type: GET_ZWAVE_DEVICE_PARAM,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(GET_ZWAVE_DEVICE_PARAM))
    try {
      await Api.getZwaveDeviceParameter(action.accessToken, action.id, action.parameterNumber)
      dispatch(apiRequestDone(GET_ZWAVE_DEVICE_PARAM))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('GET_ZWAVE_DEVICE_PARAM failed without error')
      }
    }
    done()
  },
})

export default getZwaveDeviceParameterLogic
